import { useAppTranslations } from '@treneo/shared/i18n';
import { Colors, Spacing, Typo } from '@treneo/shared/themes';
import { ApplicationLogo, Box, styled, Typography } from '@treneo/shared/ui';
import { getCurrentYear } from '@treneo/shared/utils';

const Wrapper = styled(Box)`
  margin-top: auto;
`;

const Container = styled(Box)`
  margin-top: ${Spacing.xlarge};
  background: ${Colors.white};
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  position: relative;
  padding-bottom: ${Spacing.large};
  &:before {
    content: '';
    background: ${Colors.white};
    position: absolute;
    height: 100%;
    width: 100vw;
    z-index: -1;
    margin: 0 calc(-50vw + 50%);
  }
`;

const Column = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 25px;
  padding: 25px 0;
`;

export const Footer = () => {
  const { t } = useAppTranslations();

  return (
    <Wrapper>
      <Container>
        <Column>
          <ApplicationLogo />
          <Typography>
            Treneo@{getCurrentYear()} {t('footer.allRightsReserved')}
          </Typography>
        </Column>
        <Column>
          <Typography variant={Typo.title}>{t('footer.contact')}</Typography>
          <Typography>email: kontakt@treneo.pl</Typography>
          <Typography>tel.: +48 71 88 11 689</Typography>
        </Column>
        <Column>
          <Typography variant={Typo.title}>{t('footer.navigation')}</Typography>
          <Typography>{t('footer.training')}</Typography>
          <Typography>{t('footer.whatIsTreneo')}</Typography>
          <Typography>{t('footer.myAccount')}</Typography>
          <Typography>{t('footer.privacy')}</Typography>
          <Typography>{t('footer.statue')}</Typography>
        </Column>
      </Container>
    </Wrapper>
  );
};
